import {
  parse,
  format,
  startOfDay,
  endOfDay,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
  eachDayOfInterval,
  eachWeekOfInterval,
  eachMonthOfInterval,
  eachYearOfInterval,
  getISOWeek,
  getISOWeekYear,
  getYear,
  addWeeks,
  set,
} from "date-fns";

export function sum(arr, n) {
  var total = 0;
  if (n <= arr?.length) {
    for (var i = 0; i < n; i++) {
      total += arr[i];
    }
  }
  return total;
}

export function zeroPad(num, places) {
  var zero = places - num.toString()?.length + 1;
  return Array(+(zero > 0 && zero)).join("0") + num;
}

export function getScoreRange(index) {
  switch (index) {
    case 0:
      return { gte: "0.89", lt: "1" };
    case 1:
      return { gte: "0.8", lt: "0.89" };
    case 2:
      return { gte: "0.7", lt: "0.8" };
    case 3:
      return { gte: "0.6", lt: "0.7" };
    case 4:
      return { gte: "0", lt: "0.6" };
    default:
      return {}; // Handle default case
  }
}

export function getDateRange(dateString) {
  let startDate, endDate;

  if (/^\d{2}-\d{2}-\d{4}$/.test(dateString)) {
    // days format: "MM-DD-YYYY"
    startDate = startOfDay(parse(dateString, "MM-dd-yyyy", new Date()));
    endDate = endOfDay(parse(dateString, "MM-dd-yyyy", new Date()));
  } else if (/^Week\d{1,2}-\d{4}$/.test(dateString)) {
    // weeks format: "Week##-YYYY"
    const [weekString, year] = dateString.split("-");
    const weekNumber = parseInt(weekString.slice(4), 10);
    const isoWeekStart = startOfWeek(
      parse(`${year}-01-01`, "yyyy-MM-dd", new Date()),
      { weekStartsOn: 1 }
    );
    startDate = addWeeks(isoWeekStart, weekNumber);
    endDate = endOfWeek(startDate, { weekStartsOn: 1 });
    endDate = endOfDay(endDate);
  } else if (/^\d{2}-\d{4}$/.test(dateString)) {
    // months format: "MM-YYYY"
    const [month, year] = dateString.split("-");
    startDate = startOfMonth(
      parse(`${year}-${month}-01`, "yyyy-MM-dd", new Date())
    );
    endDate = endOfMonth(startDate);
  } else if (/^\d{4}$/.test(dateString)) {
    // years format: "YYYY"
    const year = dateString;
    startDate = startOfYear(parse(`${year}-01-01`, "yyyy-MM-dd", new Date()));
    endDate = endOfYear(startDate);
  } else {
    throw new Error("Invalid date format");
  }

  return {
    start: startDate.getTime(),
    end: endDate.getTime(),
    timezone: "PST",
  };
}

export function getAllDates(startDate, endDate, period) {
  const dates = [];
  let intervals;

  const start = new Date(startDate * 1);
  const end = new Date(endDate * 1);

  switch (period) {
    case "days":
      intervals = eachDayOfInterval({ start, end });
      dates.push(...intervals.map((date) => format(date, "MM-dd-yyyy")));
      break;
    case "weeks":
      intervals = eachWeekOfInterval({ start, end });
      dates.push(
        ...intervals.map(
          (date) =>
            `Week${getISOWeek(date) <= 9 ? "0" : ""}${getISOWeek(
              date
            )}-${getISOWeekYear(date)}`
        )
      );
      break;
    case "months":
      intervals = eachMonthOfInterval({ start, end });
      dates.push(...intervals.map((date) => format(date, "MM-yyyy")));
      break;
    case "years":
      intervals = eachYearOfInterval({ start, end });
      dates.push(...intervals.map((date) => String(getYear(date))));
      break;
    default:
      return null;
  }

  return dates;
}
